(function () {
  console.log("Unified Search Redirect + Related Searches loaded");

  // ────────────────────────────────────────────────
  // 1. Get and normalize query
  // ────────────────────────────────────────────────
  let query = new URLSearchParams(window.location.search).get("q") ||
              window.location.pathname.replace(/^\/search\//, "").replace(/\/$/, "");

  if (query) query = query.toLowerCase().trim().replace(/\+/g, " ");
  if (!query) return;

  // search-form.js scopes non-shortcut searches to the title field and
  // drops stopwords (with, and, for, etc.) from that scoped query, since
  // Shopify's search treats those as unmatchable. Several redirect
  // shortcuts below rely on stopwords ("bed with headboard", "mattress for
  // kids"), so search-form.js also passes the untouched original phrase as
  // orig_q. Prefer that for the redirect check; fall back to unwrapping the
  // title: syntax out of q for the (rare) case a search reaches this page
  // without orig_q, e.g. JS disabled on submit or a manually built URL.
  const origQuery = new URLSearchParams(window.location.search).get("orig_q");
  if (origQuery) {
    query = origQuery.toLowerCase().trim();
  } else {
    const quotedTitleMatch = query.match(/^title:"(.*)"$/);
    if (quotedTitleMatch) {
      query = quotedTitleMatch[1];
    } else if (query.includes('title:')) {
      query = query
        .split(' ')
        .map((word) => (word.startsWith('title:') ? word.slice(6) : word))
        .join(' ')
        .trim();
    }
  }

  // ────────────────────────────────────────────────
  // 2. Redirect + Related Search Map
  // ────────────────────────────────────────────────
  const redirectMap = {
   // Coffee Tables
  "coffee table":       { url: "/collections/coffee-tables",       group: "coffee-tables" },
  "coffee tables":      { url: "/collections/coffee-tables",       group: "coffee-tables" },
  "living room table":  { url: "/collections/coffee-tables",       group: "coffee-tables" },
  "center table":       { url: "/collections/coffee-tables",       group: "coffee-tables" },

  // Entertainment Units
  "entertainment unit": { url: "/collections/tv-stands",           group: "entertainment-units" },
  "tv unit":            { url: "/collections/tv-stands",           group: "entertainment-units" },
  "tv stand":           { url: "/collections/tv-stands",           group: "entertainment-units" },
  "media console":      { url: "/collections/tv-stands",           group: "entertainment-units" },
  "tv cabinet":         { url: "/collections/tv-stands",           group: "entertainment-units" },
  "entertainment centre": { url: "/collections/tv-stands",         group: "entertainment-units" },
  "tv entertainment unit": { url: "/collections/tv-stands",        group: "entertainment-units" },

// Bedside Tables
"bedside table":     { url: "/collections/bedside-table", group: "bedside-tables" },
"bedside tables":    { url: "/collections/bedside-table", group: "bedside-tables" },
"bed side table":    { url: "/collections/bedside-table", group: "bedside-tables" },
"bed side tables":   { url: "/collections/bedside-table", group: "bedside-tables" },
"bedside cabinet":   { url: "/collections/bedside-table", group: "bedside-tables" },
"bedside cabinets":  { url: "/collections/bedside-table", group: "bedside-tables" },
"bed side cabinet":  { url: "/collections/bedside-table", group: "bedside-tables" },
"bed side cabinets": { url: "/collections/bedside-table", group: "bedside-tables" },
"bedside unit":      { url: "/collections/bedside-table", group: "bedside-tables" },
"bedside units":     { url: "/collections/bedside-table", group: "bedside-tables" },
"bed side unit":     { url: "/collections/bedside-table", group: "bedside-tables" },
"bed side units":    { url: "/collections/bedside-table", group: "bedside-tables" },
"nightstand":        { url: "/collections/bedside-table", group: "bedside-tables" },
"nightstands":       { url: "/collections/bedside-table", group: "bedside-tables" },
"night stand":       { url: "/collections/bedside-table", group: "bedside-tables" },
"night stands":      { url: "/collections/bedside-table", group: "bedside-tables" },

  // Tallboys
  "tall boy":           { url: "/collections/tallboys",            group: "drawers-family" },
  "tall boys":          { url: "/collections/tallboys",            group: "drawers-family" },
  "tallboy":            { url: "/collections/tallboys",            group: "drawers-family" },
  "tallboys":           { url: "/collections/tallboys",            group: "drawers-family" },
  "tall drawers":       { url: "/collections/tallboys",            group: "drawers-family" },
  "vertical dresser":   { url: "/collections/tallboys",            group: "drawers-family" },
  "bedroom tallboy":    { url: "/collections/tallboys",            group: "drawers-family" },
  "slim chest of drawers": { url: "/collections/tallboys",         group: "drawers-family" },

  // Lowboys
  "low boy":            { url: "/collections/lowboys",             group: "drawers-family" },
  "lowboy":             { url: "/collections/lowboys",             group: "drawers-family" },
  "lowboys":            { url: "/collections/lowboys",             group: "drawers-family" },
  "low chest of drawers": { url: "/collections/lowboys",           group: "drawers-family" },
  "wide dresser":       { url: "/collections/lowboys",             group: "drawers-family" },
  "short dresser":      { url: "/collections/lowboys",             group: "drawers-family" },
  "bedroom lowboy":     { url: "/collections/lowboys",             group: "drawers-family" },

  // Generic Drawers
  "drawer":             { url: "/collections/drawers",             group: "drawers-family" },
  "drawers":            { url: "/collections/drawers",             group: "drawers-family" },
  "chest drawer":       { url: "/collections/drawers",             group: "drawers-family" },
  "chest drawers":      { url: "/collections/drawers",             group: "drawers-family" },

  // Fireplaces
  "fire place":         { url: "/collections/electric-fireplace",  group: "electric-fireplaces" },
  "fire places":        { url: "/collections/electric-fireplace",  group: "electric-fireplaces" },
  "fireplace":          { url: "/collections/electric-fireplace",  group: "electric-fireplaces" },
  "fireplaces":         { url: "/collections/electric-fireplace",  group: "electric-fireplaces" },
  "electric fireplace": { url: "/collections/electric-fireplace",  group: "electric-fireplaces" },
  "freestanding fireplace": { url: "/collections/electric-fireplace", group: "electric-fireplaces" },
  "indoor fireplace":   { url: "/collections/electric-fireplace",  group: "electric-fireplaces" },
  "wall-mounted fireplace": { url: "/collections/electric-fireplace", group: "electric-fireplaces" },
  "modern fireplace":   { url: "/collections/electric-fireplace",  group: "electric-fireplaces" },
  "led fireplace":      { url: "/collections/electric-fireplace",  group: "electric-fireplaces" },

  // Bed Bases
  "bed base":           { url: "/collections/bed-bases",          group: "bed-bases" },
  "bedbase":            { url: "/collections/bed-bases",          group: "bed-bases" },
  "bed bases":          { url: "/collections/bed-bases",          group: "bed-bases" },
  "bedbases":           { url: "/collections/bed-bases",          group: "bed-bases" },
  "single bed base":      { url: "/collections/bed-bases",        group: "bed-bases" },
  "king single bed base":      { url: "/collections/bed-bases",   group: "bed-bases" },
  "double bed base":      { url: "/collections/bed-bases",        group: "bed-bases" },
  "queen bed base":      { url: "/collections/bed-bases",         group: "bed-bases" },
  "super king bed base":      { url: "/collections/bed-bases",    group: "bed-bases" },

  //Bedframes
  "bed":                { url: "/collections/bed-frames",          group: "bed-frames" },
  "beds":               { url: "/collections/bed-frames",          group: "bed-frames" },
  "bedframe":           { url: "/collections/bed-frames",          group: "bed-frames" },
  "bed frame":          { url: "/collections/bed-frames",          group: "bed-frames" },
  "bed frames":         { url: "/collections/bed-frames",          group: "bed-frames" },
  "nz bed frame":       { url: "/collections/bed-frames",          group: "bed-frames" },



  //cheap bed 
  "cheap bed frame":    { url: "/collections/metal-bed-frames", group: "bed-frames-material" },

  // Wooden Bed Frames
  "wood bed":                    { url: "/collections/wooden-bed-frames", group: "bed-frames-material" },
  "wood beds":                   { url: "/collections/wooden-bed-frames", group: "bed-frames-material" },
  "wood bed frame":              { url: "/collections/wooden-bed-frames", group: "bed-frames-material" },
  "wood bed frames":             { url: "/collections/wooden-bed-frames", group: "bed-frames-material" },
  "wooden bed":                  { url: "/collections/wooden-bed-frames", group: "bed-frames-material" },
  "wooden beds":                 { url: "/collections/wooden-bed-frames", group: "bed-frames-material" },
  "wooden bed frame":            { url: "/collections/wooden-bed-frames", group: "bed-frames-material" },
  "wooden bed frames":           { url: "/collections/wooden-bed-frames", group: "bed-frames-material" },
  "timber bed frame":            { url: "/collections/wooden-bed-frames", group: "bed-frames-material" },
  "pine bed frame":              { url: "/collections/wooden-bed-frames", group: "bed-frames-material" },

  // Metal Bed Frames
  "metal bed":                   { url: "/collections/metal-bed-frames", group: "bed-frames-material" },
  "metal beds":                  { url: "/collections/metal-bed-frames", group: "bed-frames-material" },
  "metal bed frame":             { url: "/collections/metal-bed-frames", group: "bed-frames-material" },
  "metal bed frames":            { url: "/collections/metal-bed-frames", group: "bed-frames-material" },
  "steel bed frame":             { url: "/collections/metal-bed-frames", group: "bed-frames-material" },
  "steel bed frames":            { url: "/collections/metal-bed-frames", group: "bed-frames-material" },
  "iron bed frame":              { url: "/collections/metal-bed-frames", group: "bed-frames-material" },
  "black metal bed":             { url: "/collections/metal-bed-frames", group: "bed-frames-material" },

  // Fabric Bed Frames
  "fabric bed":                  { url: "/collections/fabric-bed-frames", group: "bed-frames-material" },
  "fabric beds":                 { url: "/collections/fabric-bed-frames", group: "bed-frames-material" },
  "fabric bed frame":            { url: "/collections/fabric-bed-frames", group: "bed-frames-material" },
  "fabric bed frames":           { url: "/collections/fabric-bed-frames", group: "bed-frames-material" },
  "upholstered bed":             { url: "/collections/fabric-bed-frames", group: "bed-frames-material" },
  "upholstered bed frame":       { url: "/collections/fabric-bed-frames", group: "bed-frames-material" },
  "linen bed frame":             { url: "/collections/fabric-bed-frames", group: "bed-frames-material" },
  "velvet bed frame":            { url: "/collections/fabric-bed-frames", group: "bed-frames-material" },

  // Slatted Bed Frames
  "slat bed":                    { url: "/collections/slats-bed-frames", group: "bed-frames-type" },
  "slat bed frame":              { url: "/collections/slats-bed-frames", group: "bed-frames-type" },
  "slats bed":                   { url: "/collections/slats-bed-frames", group: "bed-frames-type" },
  "slats bed frame":             { url: "/collections/slats-bed-frames", group: "bed-frames-type" },
  "slatted bed":                 { url: "/collections/slats-bed-frames", group: "bed-frames-type" },
  "slatted bed frame":           { url: "/collections/slats-bed-frames", group: "bed-frames-type" },
  "wood slat bed frame":         { url: "/collections/slats-bed-frames", group: "bed-frames-type" },

  // Gas Lift Beds
  "gas lift bed":                { url: "/collections/gas-lift-bed-frames", group: "bed-storage" },
  "gas lift beds":               { url: "/collections/gas-lift-bed-frames", group: "bed-storage" },
  "gas lift bed frame":          { url: "/collections/gas-lift-bed-frames", group: "bed-storage" },
  "gas lift storage bed":        { url: "/collections/gas-lift-bed-frames", group: "bed-storage" },
  "lift up bed":                 { url: "/collections/gas-lift-bed-frames", group: "bed-storage" },
  "ottoman bed":                 { url: "/collections/gas-lift-bed-frames", group: "bed-storage" },
  "storage lift bed":            { url: "/collections/gas-lift-bed-frames", group: "bed-storage" },

  // Beds With Drawers
  "bed with drawers":            { url: "/collections/bed-frames-with-drawers", group: "bed-storage" },
  "beds with drawers":           { url: "/collections/bed-frames-with-drawers", group: "bed-storage" },
  "drawer bed":                  { url: "/collections/bed-frames-with-drawers", group: "bed-storage" },
  "drawer bed frame":            { url: "/collections/bed-frames-with-drawers", group: "bed-storage" },
  "storage bed":                 { url: "/collections/bed-frames-with-drawers", group: "bed-storage" },
  "storage bed frame":           { url: "/collections/bed-frames-with-drawers", group: "bed-storage" },
  "under bed storage":           { url: "/collections/bed-frames-with-drawers", group: "bed-storage" },

  // Day Beds
  "day bed":                     { url: "/collections/day-bed", group: "day-beds" },
  "day beds":                    { url: "/collections/day-bed", group: "day-beds" },
  "daybed":                      { url: "/collections/day-bed", group: "day-beds" },
  "daybeds":                     { url: "/collections/day-bed", group: "day-beds" },
  "sofa bed frame":              { url: "/collections/day-bed", group: "day-beds" },
  "guest day bed":               { url: "/collections/day-bed", group: "day-beds" },

  // Headboards
  "headboard":                   { url: "/collections/side-boards", group: "headboards" },
  "headboards":                  { url: "/collections/side-boards", group: "headboards" },
  "bed headboard":               { url: "/collections/side-boards", group: "headboards" },
  "bed headboards":              { url: "/collections/side-boards", group: "headboards" },
  "fabric headboard":            { url: "/collections/side-boards", group: "headboards" },
  "wooden headboard":            { url: "/collections/side-boards", group: "headboards" },
  "queen headboard":             { url: "/collections/side-boards", group: "headboards" },
  "king headboard":              { url: "/collections/side-boards", group: "headboards" },

    //Bed with Headboard
  "bed with headboard": { url: "/collections/bed-frames", group: "headboards" },


  // Kids Beds
  "kids bed":                    { url: "/collections/kids-beds", group: "room-combos" },
  "kids beds":                   { url: "/collections/kids-beds", group: "room-combos" },
  "children's bed":              { url: "/collections/kids-beds", group: "room-combos" },
  "child bed":                   { url: "/collections/kids-beds", group: "room-combos" },
  "kids bed frame":              { url: "/collections/kids-beds", group: "room-combos" },
  "children bed":                { url: "/collections/kids-beds", group: "room-combos" },

  // Bed & Mattress Combo
  "bed and mattress":            { url: "/collections/bed-mattress-combo", group: "combos" },
  "bed & mattress":              { url: "/collections/bed-mattress-combo", group: "combos" },
  "bed mattress combo":          { url: "/collections/bed-mattress-combo", group: "combos" },
  "bed and mattress combo":      { url: "/collections/bed-mattress-combo", group: "combos" },
  "bed & mattress combo":        { url: "/collections/bed-mattress-combo", group: "combos" },
  "bed with mattress":           { url: "/collections/bed-mattress-combo", group: "combos" },
  "bed frame and mattress":      { url: "/collections/bed-mattress-combo", group: "combos" },
  "bed frame with mattress":     { url: "/collections/bed-mattress-combo", group: "combos" },
  "complete bed":                { url: "/collections/bed-mattress-combo", group: "combos" },

  // Bunk Beds & Mattresses Combo
  "bunk bed and mattress":       { url: "/collections/bunk-beds-mattresses-combo", group: "combos" },
  "bunk bed & mattress":         { url: "/collections/bunk-beds-mattresses-combo", group: "combos" },
  "bunk bed combo":              { url: "/collections/bunk-beds-mattresses-combo", group: "combos" },
  "bunk beds with mattress":     { url: "/collections/bunk-beds-mattresses-combo", group: "combos" },
  "bunk bed with mattress":      { url: "/collections/bunk-beds-mattresses-combo", group: "combos" },
  "bunk beds and mattresses":    { url: "/collections/bunk-beds-mattresses-combo", group: "combos" },

  // Single Beds
  "single bedframe":    { url: "/collections/single-beds",         group: "single-beds" },
  "single bed frame":   { url: "/collections/single-beds",         group: "single-beds" },
  "single wooden bed frame": { url: "/collections/single-beds",    group: "single-beds" },
  "kids single bed":    { url: "/collections/single-beds",         group: "single-beds" },
  "nz single bed frame": { url: "/collections/single-beds",        group: "single-beds" },
  "single bed":         { url: "/collections/single-beds",         group: "single-beds" },

  // King Single Beds
  "king single bedframe": { url: "/collections/king-single-beds",  group: "king-single-beds" },
  "king single bed frame": { url: "/collections/king-single-beds", group: "king-single-beds" },
  "king single wooden bed": { url: "/collections/king-single-beds", group: "king-single-beds" },
  "nz king single frame": { url: "/collections/king-single-beds",  group: "king-single-beds" },
  "king single size bed": { url: "/collections/king-single-beds",  group: "king-single-beds" },
  "king single bed":    { url: "/collections/king-single-beds",    group: "king-single-beds" },

  // Double Beds
  "double bedframe":    { url: "/collections/double-beds",         group: "double-beds" },
  "double bed frame":   { url: "/collections/double-beds",         group: "double-beds" },
  "full size bed frame": { url: "/collections/double-beds",        group: "double-beds" },
  "double wooden bed frame": { url: "/collections/double-beds",    group: "double-beds" },
  "nz double bed frame": { url: "/collections/double-beds",        group: "double-beds" },
  "double bed":         { url: "/collections/double-beds",         group: "double-beds" },

  // Queen Beds
  "queen bedframe":     { url: "/collections/queen-beds",          group: "queen-beds" },
  "queen bed frame":    { url: "/collections/queen-beds",          group: "queen-beds" },
  "queen wooden bed frame": { url: "/collections/queen-beds",      group: "queen-beds" },
  "queen size bed frame": { url: "/collections/queen-beds",        group: "queen-beds" },
  "nz queen bed frame": { url: "/collections/queen-beds",          group: "queen-beds" },
  "queen bed":          { url: "/collections/queen-beds",          group: "queen-beds" },

  // King Beds
  "king bedframe":      { url: "/collections/king-beds",           group: "king-beds" },
  "king bed frame":     { url: "/collections/king-beds",           group: "king-beds" },
  "king wooden bed frame": { url: "/collections/king-beds",        group: "king-beds" },
  "king size bed frame": { url: "/collections/king-beds",          group: "king-beds" },
  "nz king bed frame":  { url: "/collections/king-beds",           group: "king-beds" },
  "king bed":           { url: "/collections/king-beds",           group: "king-beds" },

  // Super King Beds
  "super king bedframe": { url: "/collections/super-king-beds",    group: "super-king-beds" },
  "super king bed frame": { url: "/collections/super-king-beds",   group: "super-king-beds" },
  "super king wooden bed frame": { url: "/collections/super-king-beds", group: "super-king-beds" },
  "nz super king bed frame": { url: "/collections/super-king-beds", group: "super-king-beds" },
  "super king bed":     { url: "/collections/super-king-beds",     group: "super-king-beds" },

  // ── Mattresses ───────────────────────────────────────────────────────────────

    // Generic Mattresses
  "matress":                  { url: "/collections/mattresses",               group: "generic-mattresses" },
  "mattress":                 { url: "/collections/mattresses",               group: "generic-mattresses" },
  "mattresses":               { url: "/collections/mattresses",               group: "generic-mattresses" },
  "comfortable mattress":     { url: "/collections/mattresses",               group: "generic-mattresses" },
  "affordable mattress":      { url: "/collections/mattresses",               group: "generic-mattresses" },
  "quality mattress":         { url: "/collections/mattresses",               group: "generic-mattresses" },
  "nz mattress":              { url: "/collections/mattresses",               group: "generic-mattresses" },

    // Kids Mattresses
  "kids mattress":    { url: "/collections/kids-mattresses",   group: "kids-mattresses" },
  "kids bed mattress": { url: "/collections/kids-mattresses",  group: "kids-mattresses" },
  "single size mattress": { url: "/collections/kids-mattresses", group: "kids-mattresses" },
  "nz kids mattress": { url: "/collections/kids-mattresses",   group: "kids-mattresses" },
  "mattress for kids": { url: "/collections/kids-mattresses", group: "kids-mattresses" },
  "cheap kids mattress": { url: "/collections/kids-mattresses", group: "kids-mattresses" },
  "bunk beds": { url: "/collections/bunk-beds", group: "kids-mattresses" },

  // Single Mattresses
  "single mattress":    { url: "/collections/single-mattresses",   group: "single-mattresses" },
  "single bed mattress": { url: "/collections/single-mattresses",  group: "single-mattresses" },
  "single size mattress": { url: "/collections/single-mattresses", group: "single-mattresses" },
  "nz single mattress": { url: "/collections/single-mattresses",   group: "single-mattresses" },
  "mattress for single bed": { url: "/collections/single-mattresses", group: "single-mattresses" },
  "cheap single mattress": { url: "/collections/single-mattresses", group: "single-mattresses" },

  // Double Mattresses
  "double mattress":          { url: "/collections/double-mattresses",        group: "double-mattresses" },
  "double bed mattress":      { url: "/collections/double-mattresses",        group: "double-mattresses" },
  "double size mattress":     { url: "/collections/double-mattresses",        group: "double-mattresses" },
  "full size mattress":       { url: "/collections/double-mattresses",        group: "double-mattresses" },
  "nz double mattress":       { url: "/collections/double-mattresses",        group: "double-mattresses" },
  "mattress for double bed":  { url: "/collections/double-mattresses",        group: "double-mattresses" },

  // Queen Mattresses
  "queen mattress":           { url: "/collections/queen-mattresses",         group: "queen-mattresses" },
  "queen bed mattress":       { url: "/collections/queen-mattresses",         group: "queen-mattresses" },
  "queen size mattress":      { url: "/collections/queen-mattresses",         group: "queen-mattresses" },
  "nz queen mattress":        { url: "/collections/queen-mattresses",         group: "queen-mattresses" },
  "mattress for queen bed":   { url: "/collections/queen-mattresses",         group: "queen-mattresses" },

  // King Mattresses
  "king mattress":            { url: "/collections/king-mattresses",          group: "king-mattresses" },
  "king bed mattress":        { url: "/collections/king-mattresses",          group: "king-mattresses" },
  "king size mattress":       { url: "/collections/king-mattresses",          group: "king-mattresses" },
  "nz king mattress":         { url: "/collections/king-mattresses",          group: "king-mattresses" },
  "mattress for king bed":    { url: "/collections/king-mattresses",          group: "king-mattresses" },

  // Super King Mattresses
  "super king mattress":      { url: "/collections/super-king-mattresses",    group: "super-king-mattresses" },
  "super king bed mattress":  { url: "/collections/super-king-mattresses",    group: "super-king-mattresses" },
  "super king size mattress": { url: "/collections/super-king-mattresses",    group: "super-king-mattresses" },
  "nz super king mattress":   { url: "/collections/super-king-mattresses",    group: "super-king-mattresses" },
  "mattress for super king bed": { url: "/collections/super-king-mattresses", group: "super-king-mattresses" },

  // Soft Mattresses
"soft mattress":             { url: "/collections/soft-medium-mattresses", group: "soft-medium-mattresses" },
"soft mattresses":           { url: "/collections/soft-medium-mattresses", group: "soft-medium-mattresses" },
"plush mattress":            { url: "/collections/soft-medium-mattresses", group: "soft-medium-mattresses" },
"plush mattresses":          { url: "/collections/soft-medium-mattresses", group: "soft-medium-mattresses" },
"extra soft mattress":       { url: "/collections/soft-medium-mattresses", group: "soft-medium-mattresses" },
"luxury soft mattress":      { url: "/collections/soft-medium-mattresses", group: "soft-medium-mattresses" },
"comfortable soft mattress": { url: "/collections/soft-medium-mattresses", group: "soft-medium-mattresses" },

// Medium Mattresses

"medium mattress":           { url: "/collections/medium-firm-mattresses", group: "medium-mattresses" },
"medium mattresses":         { url: "/collections/medium-firm-mattresses", group: "medium-mattresses" },
"medium firm mattress":      { url: "/collections/medium-firm-mattresses", group: "medium-mattresses" },
"medium firm mattresses":    { url: "/collections/medium-firm-mattresses", group: "medium-mattresses" },
"medium soft mattress":      { url: "/collections/medium-firm-mattresses", group: "medium-mattresses" },
"balanced mattress":         { url: "/collections/medium-firm-mattresses", group: "medium-mattresses" },

// Firm Mattresses

"firm mattress":             { url: "/collections/firm-mattresses", group: "firm-mattresses" },
"firm mattresses":           { url: "/collections/firm-mattresses", group: "firm-mattresses" },
"firm support mattress":     { url: "/collections/firm-mattresses", group: "firm-mattresses" },
"supportive mattress":       { url: "/collections/firm-mattresses", group: "firm-mattresses" },
"best firm mattress":        { url: "/collections/firm-mattresses", group: "firm-mattresses" },

// Super Firm / Orthopedic Mattresses

"super firm mattress":       { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },
"super firm mattresses":     { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },
"extra firm mattress":       { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },
"extra firm mattresses":     { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },
"very firm mattress":        { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },
"hard mattress":             { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },
"hard mattresses":           { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },
"orthopedic mattress":       { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },
"orthopaedic mattress":      { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },
"back support mattress":     { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },
"mattress for back pain":    { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },
"best extra firm mattress":  { url: "/collections/super-firm-mattresses", group: "super-firm-mattresses" },

// Essential Mattresses
"essential mattress":           { url: "/collections/essential-mattresses", group: "mattress-grade" },
"essential mattresses":         { url: "/collections/essential-mattresses", group: "mattress-grade" },
"essential bed":                { url: "/collections/essential-mattresses", group: "mattress-grade" },
"essential beds":               { url: "/collections/essential-mattresses", group: "mattress-grade" },
"budget mattress":              { url: "/collections/essential-mattresses", group: "mattress-grade" },
"cheap mattress":               { url: "/collections/essential-mattresses", group: "mattress-grade" },
"entry level mattress":         { url: "/collections/essential-mattresses", group: "mattress-grade" },

// Comfort Mattresses
"comfort mattress":             { url: "/collections/comfort-mattresses", group: "mattress-grade" },
"comfort mattresses":           { url: "/collections/comfort-mattresses", group: "mattress-grade" },
"comfort bed":                  { url: "/collections/comfort-mattresses", group: "mattress-grade" },
"comfort beds":                 { url: "/collections/comfort-mattresses", group: "mattress-grade" },
"comfortable mattress":         { url: "/collections/comfort-mattresses", group: "mattress-grade" },

// Premium Mattresses
"premium mattress":             { url: "/collections/premium-mattresses", group: "mattress-grade" },
"premium mattresses":           { url: "/collections/premium-mattresses", group: "mattress-grade" },
"premium bed":                  { url: "/collections/premium-mattresses", group: "mattress-grade" },
"premium beds":                 { url: "/collections/premium-mattresses", group: "mattress-grade" },
"high end mattress":            { url: "/collections/premium-mattresses", group: "mattress-grade" },

// Luxury Mattresses
"luxury mattress":              { url: "/collections/luxury-mattresses", group: "mattress-grade" },
"luxury mattresses":            { url: "/collections/luxury-mattresses", group: "mattress-grade" },
"luxury bed":                   { url: "/collections/luxury-mattresses", group: "mattress-grade" },
"luxury beds":                  { url: "/collections/luxury-mattresses", group: "mattress-grade" },
"hotel mattress":               { url: "/collections/luxury-mattresses", group: "mattress-grade" },
"hotel style mattress":         { url: "/collections/luxury-mattresses", group: "mattress-grade" },

  // Dishwashers
  "dishwasher":               { url: "/collections/dishwashers",              group: "dishwashers" },
  "dishwashers":              { url: "/collections/dishwashers",              group: "dishwashers" },
  "dish washer":              { url: "/collections/dishwashers",              group: "dishwashers" },
  "dish washers":             { url: "/collections/dishwashers",              group: "dishwashers" },

  // Mattress Toppers
  "toppers":                  { url: "/collections/toppers",                  group: "mattress-toppers" },
  "topper":                   { url: "/collections/toppers",                  group: "mattress-toppers" },
  "mattress topper":          { url: "/collections/toppers",                  group: "mattress-toppers" },
  "mattress toppers":         { url: "/collections/toppers",                  group: "mattress-toppers" },
  "bed topper":               { url: "/collections/toppers",                  group: "mattress-toppers" },
  "bed toppers":              { url: "/collections/toppers",                  group: "mattress-toppers" },
  "foam topper":              { url: "/collections/toppers",                  group: "mattress-toppers" },
  "foam mattress topper":     { url: "/collections/toppers",                  group: "mattress-toppers" },
  "nz mattress topper":       { url: "/collections/toppers",                  group: "mattress-toppers" },
  "soft mattress topper":     { url: "/collections/toppers",                  group: "mattress-toppers" },
  "firm mattress topper":     { url: "/collections/toppers",                  group: "mattress-toppers" },
  "memory foam mattress topper": { url: "/collections/toppers",               group: "mattress-toppers" },
  "mattress pad":             { url: "/collections/toppers",                  group: "mattress-toppers" },
  "mattress overlay":         { url: "/collections/toppers",                  group: "mattress-toppers" },
  "bedding topper":           { url: "/collections/toppers",                  group: "mattress-toppers" },

  // Weighted Blankets
  "blanket":                  { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "blankets":                 { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "weighted blanket":         { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "weighted blankets":        { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "heavy blanket":            { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "gravity blanket":          { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "calming blanket":          { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "anxiety blanket":          { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "sensory blanket":          { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "deep pressure blanket":    { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "weighted throw":           { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "therapeutic blanket":      { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "weighted bed blanket":     { url: "/collections/weighted-blanket",         group: "weighted-blankets" },
  "nz weighted blanket":      { url: "/collections/weighted-blanket",         group: "weighted-blankets" },

  // Brands / Collections
  "xclusive":                 { url: "/collections/xclusive",                 group: "xclusive" },
  "nz made":                  { url: "/collections/nz-made-furniture",        group: "nz-made" },
  "nz made sofa":             { url: "/collections/nz-made-sofa",             group: "nz-made" },
  "nz made bed":              { url: "/collections/nz-made-bed",              group: "nz-made" },
  "nz made bedframe":         { url: "/collections/nz-made-bed",              group: "nz-made" },
  "nz made bed frame":        { url: "/collections/nz-made-bed",              group: "nz-made" },
  "nz made mattress":         { url: "/collections/nz-made-mattress",         group: "nz-made" },

  // Samsung
  "samsung":                  { url: "/collections/samsung",                  group: "samsung" },
  "refrigerator":             { url: "/collections/refrigerator",             group: "samsung" },
  "bar fridge":               { url: "/collections/bar-fridge",               group: "samsung" },
  "fridge freezer":           { url: "/collections/fridge-freezer-combo",     group: "samsung" },
  "midea":                    { url: "/collections/midea",                    group: "samsung" },

  // Treadmills
  "treadmill":                { url: "/collections/treadmill",                group: "treadmills" },
  "treadmills":               { url: "/collections/treadmill",                group: "treadmills" },
  "tread mill":               { url: "/collections/treadmill",                group: "treadmills" },
  "tread mills":              { url: "/collections/treadmill",                group: "treadmills" },

  // Zuru Toys
  "zuru":                     { url: "/collections/zuru",                     group: "zuru-toys" },
  "toy":                      { url: "/collections/zuru",                     group: "zuru-toys" },
  "toys":                     { url: "/collections/zuru",                     group: "zuru-toys" },
  "water gun":                { url: "/collections/zuru",                     group: "zuru-toys" },
  "toy gun":                  { url: "/collections/zuru",                     group: "zuru-toys" },
  "gun":                      { url: "/collections/zuru",                     group: "zuru-toys" },
  "car toy":                  { url: "/collections/zuru",                     group: "zuru-toys" },

  // Kettlebells
  "kettlebell":               { url: "/collections/kettlebells",              group: "kettlebells" },
  "kettle bell":              { url: "/collections/kettlebells",              group: "kettlebells" },
  "kettle bells":             { url: "/collections/kettlebells",              group: "kettlebells" },
  "kettlebells":              { url: "/collections/kettlebells",              group: "kettlebells" },

  // Folding Beds
  "folding bed":              { url: "/collections/folding-beds",             group: "folding-beds" },
  "folding bedframe":         { url: "/collections/folding-beds",             group: "folding-beds" },
  "folding bed frame":        { url: "/collections/folding-beds",             group: "folding-beds" },
  "folding bed base":         { url: "/collections/folding-beds",             group: "folding-beds" },
  "folding bedbase":          { url: "/collections/folding-beds",             group: "folding-beds" },
  "folding beds":             { url: "/collections/folding-beds",             group: "folding-beds" },

  // Outdoor Furniture
  "outdoor":                  { url: "/collections/outdoor-garden-conservatory", group: "outdoor-furniture" },
  "outdoor furniture":        { url: "/collections/outdoor-furnitures",       group: "outdoor-furniture" },

  // Ride-On Toys
  "rideon":                   { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "ride on":                  { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "rideons":                  { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "ride ons":                 { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "rideon toy":               { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "ride on toy":              { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "rideon toys":              { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "ride on toys":             { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "ride on cars":             { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "ride on car":              { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "rideon car":               { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "rideon cars":              { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "rideon truck":             { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "rideon trucks":            { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "ride on truck":            { url: "/collections/ride-on-toys",             group: "ride-on-toys" },
  "ride on trucks":           { url: "/collections/ride-on-toys",             group: "ride-on-toys" },

  // Sofas
  "sofa":                     { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "sofas":                    { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "sectional sofa":           { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "sectional sofas":          { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "corner sofa":              { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "corner sofas":             { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "l shape sofa":             { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "l shaped sofa":            { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "recliner sofa":            { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "fabric sofa":              { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "leather sofa":             { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "modular sofa":             { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "3 seater sofa":            { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "2 seater sofa":            { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "single seater sofa":       { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "couch":                    { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "couches":                  { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "lounge suite":             { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "comfortable sofa":         { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "quality sofa":             { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "affordable sofa":          { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },
  "nz sofa":                  { url: "/collections/sofas-sectionals-sofa-beds", group: "sofas" },

    // Dining Tables
  "dining table":             { url: "/collections/dining-tables", group: "dining table" },
  "dining tables":            { url: "/collections/dining-tables", group: "dining table" },
  "table dining":             { url: "/collections/dining-tables", group: "dining table" },
  "wooden dining table":      { url: "/collections/dining-tables", group: "dining table" },
  "modern dining table":      { url: "/collections/dining-tables", group: "dining table" },
  "round dining table":       { url: "/collections/dining-tables", group: "dining table" },
  "rectangle dining table":   { url: "/collections/dining-tables", group: "dining table" },
  "extendable dining table":  { url: "/collections/dining-tables", group: "dining table" },
  "glass dining table":       { url: "/collections/dining-tables", group: "dining table" },
  "marble dining table":      { url: "/collections/dining-tables", group: "dining table" },
  "small dining table":       { url: "/collections/dining-tables", group: "dining table" },
  "large dining table":       { url: "/collections/dining-tables", group: "dining table" },
  "6 seater dining table":    { url: "/collections/dining-tables", group: "dining table" },
  "8 seater dining table":    { url: "/collections/dining-tables", group: "dining table" },
  "4 seater dining table":    { url: "/collections/dining-tables", group: "dining table" },
  "family dining table":      { url: "/collections/dining-tables", group: "dining table" },
  "kitchen dining table":     { url: "/collections/dining-tables", group: "dining table" },
  "dining room table":        { url: "/collections/dining-tables", group: "dining table" },
  "affordable dining table":  { url: "/collections/dining-tables", group: "dining table" },
  "quality dining table":     { url: "/collections/dining-tables", group: "dining table" },
  "comfortable dining table": { url: "/collections/dining-tables", group: "dining table" },
  "nz dining table":          { url: "/collections/dining-tables", group: "dining table" },

  // Dining Chairs
  "dining chair":              { url: "/collections/dining-chairs", group: "dining chairs" },
  "dining chairs":             { url: "/collections/dining-chairs", group: "dining chairs" },
  "chair dining":              { url: "/collections/dining-chairs", group: "dining chairs" },
  "wooden dining chair":       { url: "/collections/dining-chairs", group: "dining chairs" },
  "modern dining chair":       { url: "/collections/dining-chairs", group: "dining chairs" },
  "upholstered dining chair":  { url: "/collections/dining-chairs", group: "dining chairs" },
  "fabric dining chair":       { url: "/collections/dining-chairs", group: "dining chairs" },
  "leather dining chair":      { url: "/collections/dining-chairs", group: "dining chairs" },
  "velvet dining chair":       { url: "/collections/dining-chairs", group: "dining chairs" },
  "black dining chair":        { url: "/collections/dining-chairs", group: "dining chairs" },
  "white dining chair":        { url: "/collections/dining-chairs", group: "dining chairs" },
  "comfortable dining chair":  { url: "/collections/dining-chairs", group: "dining chairs" },
  "arm dining chair":          { url: "/collections/dining-chairs", group: "dining chairs" },
  "armless dining chair":      { url: "/collections/dining-chairs", group: "dining chairs" },
  "high back dining chair":    { url: "/collections/dining-chairs", group: "dining chairs" },
  "small dining chair":        { url: "/collections/dining-chairs", group: "dining chairs" },
  "dining room chair":         { url: "/collections/dining-chairs", group: "dining chairs" },
  "kitchen dining chair":      { url: "/collections/dining-chairs", group: "dining chairs" },
  "set of dining chairs":      { url: "/collections/dining-chairs", group: "dining chairs" },
  "dining chair set":          { url: "/collections/dining-chairs", group: "dining chairs" },
  "affordable dining chair":   { url: "/collections/dining-chairs", group: "dining chairs" },
  "quality dining chair":      { url: "/collections/dining-chairs", group: "dining chairs" },
  "nz dining chair":           { url: "/collections/dining-chairs", group: "dining chairs" },

  // Dining Tables & Chairs Combo
"dining set":                  { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining sets":                 { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining combo":                { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining combos":               { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining table set":            { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining table sets":           { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining table chair combo":    { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining table chair combos":   { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining table and chairs":     { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining table with chairs":    { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"table and chair set":         { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"table and chairs":            { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining room set":             { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining room furniture":       { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining furniture":            { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"4 seater dining set":         { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"4 seat dining set":           { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"4 person dining set":         { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"4 chair dining set":          { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"6 seater dining set":         { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"6 seat dining set":           { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"6 person dining set":         { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"6 chair dining set":          { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"8 seater dining set":         { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"8 seat dining set":           { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"8 person dining set":         { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"8 chair dining set":          { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"wooden dining set":           { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"round dining set":            { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"extendable dining set":       { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"modern dining set":           { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"small dining set":            { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"large dining set":            { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining table chairs":         { url: "/collections/dining-tables-chairs-combo", group: "dining" },
"dining table chairs combo":   { url: "/collections/dining-tables-chairs-combo", group: "dining" },

  // Massage Chairs
  "massage chair":               { url: "/collections/massage-chairs", group: "massage chairs" },
  "massage chairs":              { url: "/collections/massage-chairs", group: "massage chairs" },
  "recliner massage chair":      { url: "/collections/massage-chairs", group: "massage chairs" },
  "electric massage chair":      { url: "/collections/massage-chairs", group: "massage chairs" },
  "full body massage chair":     { url: "/collections/massage-chairs", group: "massage chairs" },
  "shiatsu massage chair":       { url: "/collections/massage-chairs", group: "massage chairs" },
  "zero gravity massage chair":  { url: "/collections/massage-chairs", group: "massage chairs" },
  "heated massage chair":        { url: "/collections/massage-chairs", group: "massage chairs" },
  "luxury massage chair":        { url: "/collections/massage-chairs", group: "massage chairs" },
  "portable massage chair":      { url: "/collections/massage-chairs", group: "massage chairs" },
  "home massage chair":          { url: "/collections/massage-chairs", group: "massage chairs" },
  "massage recliner":            { url: "/collections/massage-chairs", group: "massage chairs" },
  "body massage chair":          { url: "/collections/massage-chairs", group: "massage chairs" },
  "smart massage chair":         { url: "/collections/massage-chairs", group: "massage chairs" },
  "therapeutic massage chair":   { url: "/collections/massage-chairs", group: "massage chairs" },
  "massage sofa chair":          { url: "/collections/massage-chairs", group: "massage chairs" },
  "comfortable massage chair":   { url: "/collections/massage-chairs", group: "massage chairs" },
  "quality massage chair":       { url: "/collections/massage-chairs", group: "massage chairs" },
  "affordable massage chair":    { url: "/collections/massage-chairs", group: "massage chairs" },
  "nz massage chair":            { url: "/collections/massage-chairs", group: "massage chairs" },

  // Outdoor Furniture
  "outdoor furniture":            { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "outdoor furnitures":           { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "patio furniture":              { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "garden furniture":             { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "outdoor sofa":                 { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "outdoor sofas":                { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "patio sofa":                   { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "patio sofas":                  { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "outdoor couch":                { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "outdoor couches":              { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "outdoor dining set":           { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "outdoor dining table":         { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "outdoor dining chairs":        { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "garden chairs":                { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "garden table":                 { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "patio chairs":                 { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "patio table":                  { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "balcony furniture":            { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "deck furniture":               { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "outdoor lounge":               { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "outdoor lounge set":           { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "rattan outdoor furniture":     { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "wicker outdoor furniture":     { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "wooden outdoor furniture":     { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "metal outdoor furniture":      { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "waterproof outdoor furniture": { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "comfortable outdoor furniture":{ url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "quality outdoor furniture":    { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },
  "affordable outdoor furniture": { url: "/collections/outdoor-furnitures", group: "outdoor-furnitures" },

  // Gazebos
  "gazebo":                    { url: "/collections/gazebos", group: "gazebos" },
  "gazebos":                   { url: "/collections/gazebos", group: "gazebos" },
  "garden gazebo":             { url: "/collections/gazebos", group: "gazebos" },
  "garden gazebos":            { url: "/collections/gazebos", group: "gazebos" },
  "outdoor gazebo":            { url: "/collections/gazebos", group: "gazebos" },
  "outdoor gazebos":           { url: "/collections/gazebos", group: "gazebos" },
  "patio gazebo":              { url: "/collections/gazebos", group: "gazebos" },
  "patio gazebos":             { url: "/collections/gazebos", group: "gazebos" },
  "backyard gazebo":           { url: "/collections/gazebos", group: "gazebos" },
  "backyard gazebos":          { url: "/collections/gazebos", group: "gazebos" },
  "canopy gazebo":             { url: "/collections/gazebos", group: "gazebos" },
  "canopy gazebos":            { url: "/collections/gazebos", group: "gazebos" },
  "pop up gazebo":             { url: "/collections/gazebos", group: "gazebos" },
  "pop up gazebos":            { url: "/collections/gazebos", group: "gazebos" },
  "pop-up gazebo":             { url: "/collections/gazebos", group: "gazebos" },
  "pop-up gazebos":            { url: "/collections/gazebos", group: "gazebos" },
  "marquee":                   { url: "/collections/gazebos", group: "gazebos" },
  "marquees":                  { url: "/collections/gazebos", group: "gazebos" },
  "shade gazebo":              { url: "/collections/gazebos", group: "gazebos" },
  "bbq gazebo":                { url: "/collections/gazebos", group: "gazebos" },
  "party gazebo":              { url: "/collections/gazebos", group: "gazebos" },
  "event gazebo":              { url: "/collections/gazebos", group: "gazebos" },
  "waterproof gazebo":         { url: "/collections/gazebos", group: "gazebos" },
  "3x3 gazebo":                { url: "/collections/gazebos", group: "gazebos" },
  "3m x 3m gazebo":            { url: "/collections/gazebos", group: "gazebos" },
  "outdoor canopy":            { url: "/collections/gazebos", group: "gazebos" },

// Pergolas
"pergola":                    { url: "/collections/pergolas", group: "pergolas" },
"pergolas":                   { url: "/collections/pergolas", group: "pergolas" },
"outdoor shelter":            { url: "/collections/pergolas", group: "pergolas" },
"patio shelter":              { url: "/collections/pergolas", group: "pergolas" },
"garden shelter":             { url: "/collections/pergolas", group: "pergolas" },
"pergola canopy":             { url: "/collections/pergolas", group: "pergolas" },
"pergola canopy outdoor":     { url: "/collections/pergolas", group: "pergolas" },

// Ride On Toys
"ride on toy":               { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on toys":              { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on car":               { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on cars":              { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"electric ride on":          { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"electric ride on car":      { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"kids ride on":              { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"kids ride on car":          { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"battery car":               { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"battery operated car":      { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"electric toy car":          { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"kids electric car":         { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on jeep":              { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on truck":             { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on tractor":           { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on atv":               { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on bike":              { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on motorbike":         { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on kart":              { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on police car":        { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"licensed ride on":          { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"licensed ride on car":      { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"kids electric vehicle":     { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on toys nz":           { url: "/collections/ride-on-toys", group: "ride-on-toys" },
"ride on toy nz":            { url: "/collections/ride-on-toys", group: "ride-on-toys" },

"sofa bed":                  { url: "/collections/sofa-beds", group: "sofa-beds" },
"sofa beds":                 { url: "/collections/sofa-beds", group: "sofa-beds" },
"pull out sofa":             { url: "/collections/sofa-beds", group: "sofa-beds" },
"pull out sofa bed":         { url: "/collections/sofa-beds", group: "sofa-beds" },
"fold out sofa":             { url: "/collections/sofa-beds", group: "sofa-beds" },
"convertible sofa":          { url: "/collections/sofa-beds", group: "sofa-beds" },
"convertible sofa bed":      { url: "/collections/sofa-beds", group: "sofa-beds" },
"sleeper sofa":              { url: "/collections/sofa-beds", group: "sofa-beds" },
"sleeper couch":             { url: "/collections/sofa-beds", group: "sofa-beds" },
"double sofa bed":           { url: "/collections/sofa-beds", group: "sofa-beds" },
"single sofa bed":           { url: "/collections/sofa-beds", group: "sofa-beds" },
"queen sofa bed":            { url: "/collections/sofa-beds", group: "sofa-beds" },
"fabric sofa bed":           { url: "/collections/sofa-beds", group: "sofa-beds" },
"corner sofa bed":           { url: "/collections/sofa-beds", group: "sofa-beds" },
"small sofa bed":            { url: "/collections/sofa-beds", group: "sofa-beds" },
"compact sofa bed":          { url: "/collections/sofa-beds", group: "sofa-beds" },
"guest sofa bed":            { url: "/collections/sofa-beds", group: "sofa-beds" },
"affordable sofa bed":       { url: "/collections/sofa-beds", group: "sofa-beds" },
"sofa bed nz":               { url: "/collections/sofa-beds", group: "sofa-beds" },
"sofa beds nz":              { url: "/collections/sofa-beds", group: "sofa-beds" },

// Projector Screens
"projector screen":              { url: "/collections/projectors-screens", group: "projector-screens" },
"projector screens":             { url: "/collections/projectors-screens", group: "projector-screens" },
"projector":                     { url: "/collections/projectors-screens", group: "projector-screens" },
"projectors":                    { url: "/collections/projectors-screens", group: "projector-screens" },
"projection screen":             { url: "/collections/projectors-screens", group: "projector-screens" },
"projection screens":            { url: "/collections/projectors-screens", group: "projector-screens" },
"movie projector screen":        { url: "/collections/projectors-screens", group: "projector-screens" },
"movie projector screens":       { url: "/collections/projectors-screens", group: "projector-screens" },
"home projector screen":         { url: "/collections/projectors-screens", group: "projector-screens" },
"home projector screens":        { url: "/collections/projectors-screens", group: "projector-screens" },
"home cinema screen":            { url: "/collections/projectors-screens", group: "projector-screens" },
"home cinema screens":           { url: "/collections/projectors-screens", group: "projector-screens" },
"home theatre screen":           { url: "/collections/projectors-screens", group: "projector-screens" },
"home theatre screens":          { url: "/collections/projectors-screens", group: "projector-screens" },
"home theater screen":           { url: "/collections/projectors-screens", group: "projector-screens" },
"home theater screens":          { url: "/collections/projectors-screens", group: "projector-screens" },
"cinema screen":                 { url: "/collections/projectors-screens", group: "projector-screens" },
"cinema screens":                { url: "/collections/projectors-screens", group: "projector-screens" },
"movie screen":                  { url: "/collections/projectors-screens", group: "projector-screens" },
"movie screens":                 { url: "/collections/projectors-screens", group: "projector-screens" },
"projector screen nz":           { url: "/collections/projectors-screens", group: "projector-screens" },
"projector screens nz":          { url: "/collections/projectors-screens", group: "projector-screens" },
"projection screen nz":          { url: "/collections/projectors-screens", group: "projector-screens" },
"portable projector screen":     { url: "/collections/projectors-screens", group: "projector-screens" },
"portable projector screens":    { url: "/collections/projectors-screens", group: "projector-screens" },
"portable projection screen":    { url: "/collections/projectors-screens", group: "projector-screens" },
"portable projection screens":   { url: "/collections/projectors-screens", group: "projector-screens" },
"foldable projector screen":     { url: "/collections/projectors-screens", group: "projector-screens" },
"foldable projector screens":    { url: "/collections/projectors-screens", group: "projector-screens" },
"pull down projector screen":    { url: "/collections/projectors-screens", group: "projector-screens" },
"pull down projector screens":   { url: "/collections/projectors-screens", group: "projector-screens" },
"retractable projector screen":  { url: "/collections/projectors-screens", group: "projector-screens" },
"retractable projector screens": { url: "/collections/projectors-screens", group: "projector-screens" },
"electric projector screen":     { url: "/collections/projectors-screens", group: "projector-screens" },
"electric projector screens":    { url: "/collections/projectors-screens", group: "projector-screens" },
"manual projector screen":       { url: "/collections/projectors-screens", group: "projector-screens" },
"manual projector screens":      { url: "/collections/projectors-screens", group: "projector-screens" },

  // Bestway
  "bestway":                  { url: "/collections/bestway",                  group: "bestway" },
  "best way":                 { url: "/collections/bestway",                  group: "bestway" },
  };

  const current = redirectMap[query];

  // ────────────────────────────────────────────────
  // 3. If match → redirect + store context
  // ────────────────────────────────────────────────
  if (current) {
    sessionStorage.setItem("search_redirect", JSON.stringify({
      query,
      group: current.group,
      url: current.url
    }));

    window.location.replace(current.url);
    return;
  }

  // ────────────────────────────────────────────────
  // 4. Related Searches (ONLY after redirect landing)
  // ────────────────────────────────────────────────
  window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      const redirectData = sessionStorage.getItem("search_redirect");
      if (!redirectData) return;

      const { query: originalQuery, group } = JSON.parse(redirectData);

      // clear after use (prevents re-trigger on refresh)
      sessionStorage.removeItem("search_redirect");

      const relatedQueries = Object.keys(redirectMap)
        .filter(key => key !== originalQuery && redirectMap[key].group === group)
        .sort((a, b) => a.localeCompare(b));

      if (!relatedQueries.length) return;

      const container = document.createElement("div");
      container.className = "related-searches";
      container.style.display = "flex";
      container.style.flexDirection = "column";
      container.style.alignItems = "center";
      container.style.opacity = "0";
      container.style.transition = "opacity 0.4s ease";
      container.style.margin = "30px 0";

      const title = document.createElement("h3");
      title.textContent = "Related Searches";
      title.style.fontSize = "20px";
      title.style.marginBottom = "12px";
      container.appendChild(title);

      const list = document.createElement("div");
      list.style.display = "flex";
      list.style.flexWrap = "wrap";
      list.style.gap = "10px";
      list.style.justifyContent = "center";
      container.appendChild(list);

      const isMobile = window.innerWidth <= 768;
      const maxMobileItems = 8;

      relatedQueries.forEach((item, index) => {
        const link = document.createElement("a");
        link.textContent = item;
        link.href = redirectMap[item].url;

        link.style.padding = "6px 14px";
        link.style.borderRadius = "999px";
        link.style.background = "#f5f5f5";
        link.style.color = "#333";
        link.style.textDecoration = "none";
        link.style.fontSize = "14px";
        link.style.border = "1px solid #e0e0e0";

        // Hover effects
        link.addEventListener("mouseenter", () => {
          link.style.background = "#e13137";
          link.style.color = "#ffffff";
          link.style.borderColor = "#e13137";
        });

        link.addEventListener("mouseleave", () => {
          link.style.background = "#f5f5f5";
          link.style.color = "#333";
          link.style.borderColor = "#e0e0e0";
        });

        if (isMobile && index >= maxMobileItems) {
          link.style.display = "none";
          link.classList.add("mobile-hidden");
        }

        list.appendChild(link);
      });

      // Load more (mobile)
      if (isMobile && relatedQueries.length > maxMobileItems) {
        let expanded = false;

        const btn = document.createElement("button");
        btn.textContent = "Load More";
        btn.style.marginTop = "12px";
        btn.style.padding = "6px 14px";
        btn.style.border = "1px solid #d62828";
        btn.style.background = "#d62828";
        btn.style.color = "#fff";
        btn.style.borderRadius = "6px";

        btn.addEventListener("click", () => {
          expanded = !expanded;
          document.querySelectorAll(".mobile-hidden").forEach(el => {
            el.style.display = expanded ? "inline-flex" : "none";
          });
          btn.textContent = expanded ? "Show Less" : "Load More";
        });

        container.appendChild(btn);
      }

      const target =
        document.querySelector("#related-searches") ||
        document.querySelector(".search-results") ||
        document.querySelector("main") ||
        document.body;

      target.appendChild(container);
      requestAnimationFrame(() => (container.style.opacity = "1"));
    }, 80);
  });
})();